<template>
  <div class="message">
    <div class="message-header is-unselectable">
      <span>
        {{ title }}
      </span>
      <icon :name="icon" v-if="icon" />
    </div>

    <div class="message-body">
      <slot />
    </div>
  </div>
</template>

<script>
import { Icon } from "%helpers";

export default {
  name: "message-box",

  components: {
    Icon
  },

  props: {
    title: String,
    icon: String
  }
};
</script>

<style lang="scss" scoped>
.message-body {
  ul {
    list-style: none;
    margin-left: 2.5rem;

    li {
      text-indent: -1.5rem;
      margin: 0.3rem 0;

      &::before {
        content: "\f105";
        font-family: "Font Awesome 5 Pro";
        font-weight: 700;
        float: left;
        width: 1.5rem;
        color: $primary;
      }
    }
  }
}
</style>
